import React, { useContext } from 'react';
import { Row, Typography, Card, Modal } from 'antd';
import { GoLocation, GoClock } from 'react-icons/go';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import { History } from 'history';
import i18n from 'i18next';
import { OldOrderButton } from '../../layout/GlobalButton';
import { CoverImageDetails } from './CoverImage';
import { PlaceOrderHandler } from '../../orders/PlaceOrder';
import { CookMeals } from '../../../store/cooksprofile/types';
import { AuthModalContent } from '../../layout/Header';
import { AccountTypeContext } from '../../dashboard/Dashboard';
import { useSelector } from 'react-redux';
import { getUserState } from '../../../store/user/selector';

const BREAKFAST_TIME = '7 AM – 11 AM';
const LUNCH_TIME = '11 AM – 17 PM';
const DINNER_TIME = '17 PM – 23 PM';

export interface ScheduleProps {
  date?: Date;
  time?: string[];
}

export interface CardState {
  meal: CookMeals;
  schedule?: ScheduleProps[];
  image?: string;
  price?: string;
  title?: string;
  isGuest: boolean;
  location: string;
}

export const getScheduleTime = (scheduleTime: string | undefined) => {
  let time = '';
  switch (scheduleTime) {
    case 'Breakfast':
      time = BREAKFAST_TIME;
      break;
    case 'Lunch':
      time = LUNCH_TIME;
      break;
    case 'Dinner':
      time = DINNER_TIME;
      break;
    default:
      time = '';
  }
  return time;
};

export const FoodList: React.FC<CardState> = ({
  schedule,
  price,
  title,
  image,
  meal,
  isGuest,
  location,
}) => {
  const history: History = useHistory();
  const getFirstSchedule = _.head(schedule);
  const getFirstScheduleTime = _.head(getFirstSchedule?.time);
  const time = getScheduleTime(getFirstScheduleTime);
  const { forWho } = useContext(AccountTypeContext);
  const { user } = useSelector(getUserState);
  const newitems = {
    ...meal,
    time: time,
    isGuest,
  };

  const handleOnclickCard = () => {
    history.push({
      pathname: '/mealdetails',
      state: newitems,
    });
  };

  const handleCancelPress = () => {
    Modal.destroyAll();
  };

  const handleLinkClick = (link: string) => (): void => {
    history.push(link);

    setTimeout(() => {
      Modal.destroyAll();
    }, 500);
  };

  const restrictionModalConfig = {
    icon: null,
    false: true,
    maskClosable: true,
    className: 'modal-content-container modal-content-description',
    okButtonProps: { style: { display: 'none' } },
    content: (
      <AuthModalContent
        onCreateAccountPress={handleLinkClick(
          `/authentication/registration/${forWho}`
        )}
        onLoginAccountPress={handleLinkClick(
          `/authentication/login/email/${forWho}`
        )}
        onPressCancel={handleCancelPress}
      />
    ),
  };

  const handleOnClickItem = () => {
    if (user.userid) {
      PlaceOrderHandler({ meal, history });
      return;
    }
    Modal.info(restrictionModalConfig);
  };
  return (
    <div>
      <Row justify="end" className="foodlist-icon-container">
        <Row className="icon-container">
          <GoLocation color="#B0B1B2" size={15} />
          <Typography.Text className="kilometer-text">
            {location}
          </Typography.Text>
        </Row>
        <Row className="icon-container">
          {time !== '' ? (
            <GoClock
              size={15}
              color="#939393"
              style={{ marginRight: '10px' }}
            />
          ) : null}
          {time !== '' ? <span>{time}</span> : i18n.t('CONSTANT_OFFER')}
        </Row>
      </Row>
      <Card
        bordered={false}
        cover={<CoverImageDetails price={price} title={title} image={image} />}
        onClick={handleOnclickCard}
      />
      <OldOrderButton onclick={handleOnClickItem} />
    </div>
  );
};
